export const GET_CHECK_TICKET_PAY_OUT_PATH = `/tickets/check_ticket_pay_out`;
